export default "__VITE_ASSET__BrsxWHhp__"